import {
    CancelMatch,
    DisplayCommand,
    DisplayCommandType,
    MatchInfo,
    MatchTeam,
    PitUpdate, PlayVideo,
    Randomize,
    Redirect,
    ScoreUpdate,
    ShowAdvancement,
    ShowAward,
    ShowBlank,
    ShowBracket, ShowInspectionStatus,
    ShowKey,
    ShowMessage,
    ShowOnlineResults,
    ShowPreview,
    ShowRandom,
    ShowRankings,
    ShowResults, ShowRoundResults, ShowSafetySecurity,
    ShowSelection,
    ShowSetup, ShowSlideshow,
    ShowSponsors,
    ShowVideo,
    ShowWifi,
    TimeoutUpdate
} from "../javaTypes";

const TIMEOUT_UPDATES = [DisplayCommandType.SHOW_TIMEOUT, DisplayCommandType.END_TIMEOUT, DisplayCommandType.TIMEOUT_UPDATE];
const IN_MATCH_UPDATES = [DisplayCommandType.SHOW_MATCH, DisplayCommandType.START_MATCH, DisplayCommandType.ABORT_MATCH];

export function isMatchUpdate(msg: DisplayCommand<any>): msg is DisplayCommand<MatchInfo<unknown>> {
    return 'field' in msg.params && !isRedirect(msg);
}

export function isTimeoutUpdate(msg: DisplayCommand<unknown>): msg is DisplayCommand<TimeoutUpdate> {
    return TIMEOUT_UPDATES.includes(msg.type);
}

export function isCancelMatch(msg: DisplayCommand<any>): msg is DisplayCommand<CancelMatch> {
    return msg.type == DisplayCommandType.CANCEL_MATCH;
}

export function isRandomization(msg: DisplayCommand<unknown>): msg is DisplayCommand<Randomize & ShowRandom> {
    return msg.type == DisplayCommandType.RANDOMIZE || msg.type == DisplayCommandType.SHOW_RANDOM;
}

export function isShowBlank(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowBlank> {
    return msg.type == DisplayCommandType.SHOW_BLANK;
}

export function isShowVideo(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowVideo> {
    return msg.type == DisplayCommandType.SHOW_VIDEO;
}

export function isShowKey(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowKey> {
    return msg.type == DisplayCommandType.SHOW_KEY;
}

export function isShowSetup(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowSetup> {
    return msg.type == DisplayCommandType.SHOW_SETUP;
}

export function isShowPreview(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowPreview> {
    return msg.type == DisplayCommandType.SHOW_PREVIEW;
}

export function isShowRankings(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowRankings> {
    return msg.type == DisplayCommandType.SHOW_RANKINGS;
}

export function isShowInspectionStatus(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowInspectionStatus> {
    return msg.type == DisplayCommandType.SHOW_INSPECTION_STATUS;
}

export function isShowSponsors(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowSponsors> {
    return msg.type == DisplayCommandType.SHOW_SPONSORS;
}

export function isInMatchUpdate(msg: DisplayCommand<unknown>): msg is DisplayCommand<MatchInfo<MatchTeam>> {
    return IN_MATCH_UPDATES.includes(msg.type);
}

export function isShowResults(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowResults> {
    return msg.type == DisplayCommandType.SHOW_RESULTS;
}

export function isShowRoundResults(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowRoundResults> {
    return msg.type == DisplayCommandType.SHOW_ROUND_RESULTS;
}

export function isShowMessage(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowMessage> {
    return msg.type == DisplayCommandType.SHOW_MESSAGE;
}

export function isShowWifi(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowWifi> {
    return msg.type == DisplayCommandType.SHOW_WIFI;
}

export function isShowSafetySecurity(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowSafetySecurity> {
    return msg.type == DisplayCommandType.SHOW_SAFETY_SECURITY;
}

export function isShowSlideshow(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowSlideshow> {
    return msg.type == DisplayCommandType.SHOW_SLIDESHOW;
}

export function isShowSelection(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowSelection> {
    return msg.type == DisplayCommandType.SHOW_SELECTION;
}

export function isShowBracket(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowBracket> {
    return msg.type == DisplayCommandType.SHOW_BRACKET;
}

export function isShowRotatingBracket(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowBracket> {
    return msg.type == DisplayCommandType.SHOW_ROTATING_BRACKET;
}

export function isShowOnlineResults(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowOnlineResults> {
    return msg.type == DisplayCommandType.SHOW_ONLINE_RESULTS;
}

export function isShowAward(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowAward> {
    return msg.type == DisplayCommandType.SHOW_AWARD;
}

export function isShowAdvancement(msg: DisplayCommand<unknown>): msg is DisplayCommand<ShowAdvancement> {
    return msg.type == DisplayCommandType.SHOW_ADVANCEMENT;
}

export function isPlayVideo(msg: DisplayCommand<unknown>): msg is DisplayCommand<PlayVideo> {
    return msg.type == DisplayCommandType.PLAY_VIDEO;
}

export function isScoreUpdate(msg: DisplayCommand<unknown>): msg is DisplayCommand<ScoreUpdate> {
    return msg.type == DisplayCommandType.SCORE_UPDATE;
}

export function isRedirect(msg: DisplayCommand<unknown>): msg is DisplayCommand<Redirect> {
    return msg.type == DisplayCommandType.REDIRECT;
}

export function isPitUpdate(msg: DisplayCommand<unknown>): msg is DisplayCommand<PitUpdate<unknown>> {
    return msg.type == DisplayCommandType.PIT_UPDATE;
}
